// import types
import NavigationItem from '@/composables/useNavigation/types/NavigationItem';
import Routes from '@/enums/Routes';

export default function useNavigation() {
  // Navigation item can have parent, child and grand child level
  // Left "childNav" empty if no child and add "to" path
  // If childNav is not empty then left "to" empty
  const navigationItems: Array<NavigationItem> = [
    {
      title: 'Home',
      icon: 'mdi-home',
      to: Routes.HOME,
      childNav: [],
    },
    {
      title: 'Settings',
      icon: 'mdi-cog',
      to: Routes.SETTINGS,
      childNav: [],
    },
  ];

  return { navigationItems };
}
